import React from "react";
import {observer} from "mobx-react-lite";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";

import Input from "../../../../ui/Input";

import CompanyUserForm from "./CompanyUserForm";
import MemberTeam from "../MemberTeam";


const MemberForm = () => {
    const member =
        clubStore.member;
    const currentYear =
        new Date().getFullYear();

    return (
        <CompanyUserForm
            title={
                member.id
                    ? appStore.tr.edit
                    : appStore.tr.add_member
            }
        >
            {/* YEAR BORN */}
            <div className="col-12">
                <label
                    htmlFor="input_year_born"
                    className="block mb-1"
                >
                    {appStore.tr.year_born}
                </label>
                <Input
                    id="input_year_born"
                    type="number"
                    store={member}
                    prop="year_born"
                    label={
                        appStore.tr.year_born
                    }
                    min={1900}
                    max={currentYear}
                    required
                />
            </div>
            {/* UNIFORM NUMBER */}
            <div className="col-12">
                <label
                    htmlFor="input_forma_number"
                    className="block mb-1"
                >
                    {appStore.tr.forma_number}
                </label>
                <Input
                    id="input_forma_number"
                    store={member}
                    prop="forma_number"
                    label={
                        appStore.tr.forma_number
                    }
                    required
                />
            </div>
            {/* PAYMENT / DISCOUNT VALUE */}
            <div className="col-12">
                <label
                    htmlFor="input_discount_amount"
                    className="block mb-1"
                >
                    {appStore.tr.discount_amount}
                </label>
                <Input
                    id="input_discount_amount"
                    type="number"
                    store={member}
                    prop="discount_amount"
                    label={
                        appStore.tr.discount_amount
                    }
                    min={0}
                />
            </div>
            <MemberTeam />
        </CompanyUserForm>
    );
};


export default observer(
    MemberForm
);